import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { store } from './redux/store/store';

import 'antd/dist/antd.css';
import './index.css';

render(
  <Provider store={store}>
    <Router basename='/'>
      <Route path='/' component={App} />
    </Router>
  </Provider>,
  document.querySelector('#root')
);

serviceWorker.unregister();
